import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { Promotions } from "./Promotions/Promotions";
import { HomePageCarousel } from "./HomePageCarousel/HomePageCarousel";
import { AdsBanner } from "./AdsBanner/AdsBanner";
import { Icon } from "@iconify/react";

export const Advertisement = () => {
  const query = useQuery();
  const navigate = useNavigate();
  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/eraman/advertisement?activeTab=campaign`, {
        replace: true,
      });
    }
  }, []);
 
  const items = [
    {
      label: "Campaign",
      key: "campaign",
      children: <Promotions />,
    },
    {
      label: "Home Page Carousel",
      key: "homePageCarousel",
      children: <HomePageCarousel />,
    },
    {
      label: "Banner",
      key: "banner",
      children: <AdsBanner />,
    },
  ];

  const handleProductManagement=(activeTab:any)=>{
    if(activeTab === 'campaign') {
      return (<Button
      onClick={() => {
        navigate("/dedicated/eraman/advertisement/campaign/add");
      }}
      icon={<Icon icon={"lucide:plus"} />}
      >
        Add Campaign
      </Button>
      )
    } else if(activeTab === 'homePageCarousel') {
        return (<Button
        onClick={() => {
          navigate("/dedicated/eraman/advertisement/homePageCarousel/add");
        }}
        icon={<Icon icon={"lucide:plus"} />}
      >
        Add Homepage Carousel
      </Button>
      )
    } 
  }

  return (
    <ContentWrapper title={"Advertisement"} bodyStyle={{height: "calc(100vh - 100px)", overflowY: "auto" }}
    actionItems={
      handleProductManagement(query.get('activeTab'))
    }>
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey === "banner" ? "banner&subActiveTab=bannerPromotion" : activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
